"use client"
import { SingleProductMeasurement } from '@/types/product';
import { useTranslate } from '@tolgee/react';

export const ProdutMeasurementRow = ({
  measurement,
}: {
  measurement: SingleProductMeasurement;
}) => {
  const { t } = useTranslate();
  const { label, inches, cm } = measurement;
  return (
    <div className='border rounded-sm grid grid-cols-3 text-center label-md'>
      <div className='border-r py-3'>{label}</div>
      <div className='border-r py-3'>
        {inches} {t("product_measurement_row.inches_short")}
      </div>
      <div className='py-3'>
        {cm} {t("product_measurement_row.cm_short")}
      </div>
    </div>
  );
};
